module.exports = __webpack_public_path__ + "img/DSG_logo.e0317d19.png";